<template>
<transition name="slide-fade">
    <div class="dialog-view" v-if="dialogVisible">        
        <div class="apply-modal u-window">           
            <div class="dialog-content">
                <div class="u-btn close" @click="destroyElement ()"></div>
                <div class="dialog-wrapper">
                    <div class="t-apply"></div>

                    <div class="msg-view">
                        <div class="text">
                            <p>确认接受【 <b>{{ player_data.nickName }}</b>】的邀请，</p>
                            <p>共同完成张春华限时任务！</p>
                        </div>
                        <div class="tips">加入后仅可退队1次</div>
                    </div>            

                    <div class="u-ctrl">
                        <div class="u-btn cancel" @click="destroyElement ()"></div>  
                        <div class="u-btn ok" @click="apply"></div>                                                                 
                    </div>
                    
                </div>
            </div>            
        </div>

        <div class="u-mask"></div>
    </div>
</transition>       
</template>

<style lang="scss" scoped>
@include responseTo("desktop"){
    .apply-modal{
        transform: scale(0.8);
    }

}

.apply-modal{
    position: relative;
    width: 650px;
    height: 464px;
    background-image: url(~@/assets/images/modal/bg-modal.png);    
}

.t-apply{
    width: 323px;
    height: 41px;
    margin: 0 auto 20px;
    background-image: url(~@/assets/images/modal/title-invite_apply.png);
}

.msg-view{
    height: 150px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    text-align: center;
    margin: 0 auto 0;
    padding: 40px 24px 0;
    line-height: 1.6;
    color: #daefff;

    font-size: 22px;

    .tips{
        padding: 0 60px;
        color: #f24eab;
    }    
}

.notice{
    margin-top: 22px;
    text-align: center;
    color: #f24eab;
}

.warn{
    font-size: 22px;
    text-align: center;
    color: #de482b;
}

.u-ctrl{
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 40px;
    padding: 0 20px;
}

.u-btn.ok{
    width: 279px;
    height: 87px;
    margin: 0 10px;
    background-image: url(~@/assets/images/modal/btn-recive.png);    
}

.u-ctrl .u-btn.cancel{
    width: 279px;
    height: 87px;
    margin: 0 10px;
    background-image: url(~@/assets/images/modal/btn-cancel.png);    
}
</style>

<script>
import { apiTeamJoin , apiInviteInfo } from '@/api/index';

export default {
    data (){
        return {
            dialogVisible : false,
            code : '',
            player_data : '',
            team_switch : false,
            text : '请稍后再试', 
            error : true,
            tid : 0,
            type : 1,
            ready : false,
            fromType : 1,//1绑定码 2口令码    
        }
    },
    created (){
        document.body.style.overflow = 'hidden';
    },
    mounted(){
        this.render();
    },
    methods : {
        destroyElement () {
            this.$destroy()
            document.body.style.overflow = ''; // 出现滚动条
            this.$el.parentNode.removeChild(this.$el)
        },
        render() {
            var _this = this;
            apiInviteInfo({code : this.code}).then(
                res => {
                    this.player_data = res.data;
                },
                rej => {
                    this.error_text = rej.message || '请稍后再试';
                    this.$toast(rej.message);
                    this.$store.commit("$_setCode", '');
                    localStorage.setItem('code', '');                      
                },
            );
        },        
        apply (){

            if(!this.$store.state.login){
                return this.$mslogin.login();
            }

            if(!this.$store.state.userinfo.zid){
                this.destroyElement();
                this.$bind_modal();
                return this.$toast('请先选择大区');
            }

            this.apply_team();
        },
        apply_team (){
            apiTeamJoin({ teamCode : this.code }).then(
                res => {
                    this.destroyElement();
                    this.$msg_modal({text : '请耐心等待队长<b>'+ this.player_data.nickName +'</b> 在【申请列表】确认！'})
                    this.$store.commit("$_setCode", '');
                    localStorage.setItem('code', '');                   
                },
                rej => {
                    this.destroyElement();
                    let error = rej.code == 404 ? '该用户累计加入次数已达上限' : rej.message;
                    //this.$toast(error);
                    this.$msg_modal({text : rej.message});
                    
                    this.$store.commit("$_setCode", '');
                    localStorage.setItem('code', '');                       
                },
            );
        },                
    },
}
</script>